var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlannedCalls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5996,20.4 L17.5996,17.888 L20.3996,17.888 L20.3996,20.4 L17.5996,20.4 Z M3.5996,17.888 L6.3996,17.888 L6.3996,20.4 L3.5996,20.4 L3.5996,17.888 Z M5.9996,5.2 L5.9996,6.072 C5.9996,6.514 6.3576,6.872 6.7996,6.872 C7.2416,6.872 7.5996,6.514 7.5996,6.072 L7.5996,5.2 L16.3996,5.2 L16.3996,6.072 C16.3996,6.514 16.7576,6.872 17.1996,6.872 C17.6416,6.872 17.9996,6.514 17.9996,6.072 L17.9996,5.2 L20.3996,5.2 L20.3996,8.064 L3.5986,8.064 L3.5986,5.2 L5.9996,5.2 Z M17.5996,13.775 L20.3996,13.775 L20.3996,16.288 L17.5996,16.288 L17.5996,13.775 Z M12.7996,16.288 L16.0006,16.288 L16.0006,13.775 L12.7996,13.775 L12.7996,16.288 Z M12.7996,20.4 L16.0006,20.4 L16.0006,17.888 L12.7996,17.888 L12.7996,20.4 Z M7.9996,20.4 L11.1996,20.4 L11.1996,17.888 L7.9996,17.888 L7.9996,20.4 Z M7.9996,16.288 L11.1996,16.288 L11.1996,13.775 L7.9996,13.775 L7.9996,16.288 Z M3.5996,13.775 L6.3996,13.775 L6.3996,16.288 L3.5996,16.288 L3.5996,13.775 Z M6.3996,12.176 L3.5986,12.176 L3.5986,9.664 L6.3996,9.664 L6.3996,12.176 Z M20.3996,9.664 L20.3996,12.176 L17.5996,12.176 L17.5996,9.664 L20.3996,9.664 Z M12.7986,12.176 L15.9996,12.176 L15.9996,9.664 L12.7986,9.664 L12.7986,12.176 Z M7.9996,12.176 L11.1996,12.176 L11.1996,9.664 L7.9996,9.664 L7.9996,12.176 Z M20.3996,3.6 L17.9996,3.6 L17.9996,2.8 C17.9996,2.358 17.6416,2 17.1996,2 C16.7576,2 16.3996,2.358 16.3996,2.8 L16.3996,3.6 L7.5996,3.6 L7.5996,2.8 C7.5996,2.358 7.2416,2 6.7996,2 C6.3576,2 5.9996,2.358 5.9996,2.8 L5.9996,3.6 L3.5996,3.6 C2.7176,3.6 1.9996,4.317 1.9996,5.2 L1.9996,20.4 C1.9996,20.563 2.0316,20.718 2.0776,20.867 C2.0306,20.969 1.9996,21.08 1.9996,21.2 C1.9996,21.642 2.3576,22 2.7996,22 L3.5996,22 L20.3996,22 L21.1996,22 C21.6416,22 21.9996,21.642 21.9996,21.2 C21.9996,21.08 21.9696,20.969 21.9216,20.867 C21.9676,20.718 21.9996,20.563 21.9996,20.4 L21.9996,5.2 C21.9996,4.317 21.2816,3.6 20.3996,3.6 L20.3996,3.6 Z",
    id: "path-8ae00389-769b-4bd5-9eb0-a1ebcd79881a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "118.243242%",
    y1: "109.459461%",
    x2: "4.72973324%",
    y2: "6.08107672%",
    id: "linearGradient-8ae00389-769b-4bd5-9eb0-a1ebcd79881a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96D4F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75ACFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Navigation-/-plannedCalls"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8ae00389-769b-4bd5-9eb0-a1ebcd79881a",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8ae00389-769b-4bd5-9eb0-a1ebcd79881a"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Fill-1",
    fill: "#868B92",
    xlinkHref: "#path-8ae00389-769b-4bd5-9eb0-a1ebcd79881a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "url(#linearGradient-8ae00389-769b-4bd5-9eb0-a1ebcd79881a)",
    mask: "url(#mask-8ae00389-769b-4bd5-9eb0-a1ebcd79881a)",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannedCalls);
export default __webpack_public_path__ + "static/media/plannedCalls.ea77332cc44833cedfd191010335629d.svg";
export { ForwardRef as ReactComponent };